import { HttpClient } from '@angular/common/http';
import { CacheService } from './cache.service';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ApiConfigService } from './api-config/api-config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./cache.service";
import * as i3 from "../app-config.constants";
import * as i4 from "./api-config/api-config.service";
var RankMyAgentService = /** @class */ (function () {
    function RankMyAgentService(httpClient, cache, appConfig, apiConfigService) {
        this.httpClient = httpClient;
        this.cache = cache;
        this.appConfig = appConfig;
        this.apiConfigService = apiConfigService;
    }
    RankMyAgentService.prototype.getAgentRating = function (personifyId) {
        var _this = this;
        var apiRoot = this.apiConfigService.getServerRoot(this.appConfig.urls.agent.base);
        var route = "" + this.appConfig.urls.agent.base + personifyId + "/ratings";
        var hashKey = this.cache.getRequestHash(route, null);
        var hashValue = this.cache.get(hashKey);
        if (hashValue) {
            return of(!!hashValue['result'].personify_id ? hashValue : null); // Check if cached value has any data, otherwise return null instead of {}
        }
        return this.httpClient.get(apiRoot + route, { withCredentials: false }).pipe(catchError(function (err) { return of(null); }), // Run catchError before caching so we can cache a 404
        tap(function (rating) { return _this.cache.set(hashKey, rating, 1000); }));
    };
    RankMyAgentService.ngInjectableDef = i0.defineInjectable({ factory: function RankMyAgentService_Factory() { return new RankMyAgentService(i0.inject(i1.HttpClient), i0.inject(i2.CacheService), i0.inject(i3.APP_CONFIG), i0.inject(i4.ApiConfigService)); }, token: RankMyAgentService, providedIn: "root" });
    return RankMyAgentService;
}());
export { RankMyAgentService };
